// flags.js — feature flag della shell (R2/R3), MECCANISMO DICHIARATO.
//
// Il design §11 R2 chiede una flag "config servita, non page-load" (shell_rail_v2).
// Il server è CONGELATO in questa fase (nessun endpoint di config toccabile), quindi
// la via più semplice che resta reversibile SENZA toccare server.js è:
//
//   DEFAULT ON nel bundle + kill-switch a 2 livelli:
//    1) per-browser, immediato:  localStorage.shell_rail_v2 = '0'  (+ reload)
//       → resa rail legacy (#amm-rail) identica a R1; il Rail React non monta.
//       Analogo per il sottomenù R3: localStorage.shell_submenu_v2 = '0'.
//    2) per-deploy, globale: redeploy del manifest con il bundle shell precedente
//       (kill-switch R1 già provato: guardia workspace-host.js:13).
//
// Il sottomenù shell (R3) dipende dal rail v2 (la colonna siede a destra del rail):
// rail OFF ⇒ submenu OFF, qualunque sia la sua chiave.

export function railV2Enabled(win) {
  try {
    return win.localStorage.getItem('shell_rail_v2') !== '0';
  } catch (e) {
    return true; // storage negato: si va col default del bundle
  }
}

export function submenuShellEnabled(win) {
  if (!railV2Enabled(win)) return false;
  try {
    return win.localStorage.getItem('shell_submenu_v2') !== '0';
  } catch (e) {
    return true;
  }
}

// R4: flag di fallback PER-MODULO del sottomenù shell (design §11 R4 "per-modulo:
// submenu:'internal'"). localStorage.shell_submenu_<id>='0' (+ reload) ⇒ l'adapter
// del modulo registra submenu:'internal': il modulo tiene la sua nav interna,
// istantaneo, senza toccare gli altri. Il flag globale shell_submenu_v2 resta
// sovraordinato (host.submenuData non rende nulla se è spento).
export function moduleSubmenuEnabled(win, id) {
  try {
    return win.localStorage.getItem('shell_submenu_' + id) !== '0';
  } catch (e) {
    return true;
  }
}

// R5: presa in carico della history (design §8 TEMPO 2, §11 R5 — hook reale
// window._historyReady in proc-v0.js:16700/16432).
// DEFAULT OFF IN QUESTA ONDATA (ondata 9): a differenza delle flag R2/R3 qui il
// default del bundle è SPENTO — si accende per-browser SOLO in collaudo con
//   localStorage.shell_router = '1'   (+ reload)
// e diventerà default ON con un deploy dedicato DOPO il collaudo utente.
// Kill-switch: rimuovere la chiave (o '0') + reload ⇒ la history resta al
// monolite (buffer + popstate + pushState di showView), identico a oggi.
export function shellRouterEnabled(win) {
  try {
    return win.localStorage.getItem('shell_router') === '1';
  } catch (e) {
    return false; // storage negato: default SPENTO — mai prendere la history per sbaglio
  }
}

// F2.3 (primo mattone): Cruscotto v3 React — DEFAULT OFF nel bundle, come la R5.
// Si accende per-browser SOLO in collaudo con
//   localStorage.shell_dash_v3 = '1'   (+ reload)
// e diventerà default ON con un deploy dedicato DOPO il collaudo utente.
// Kill-switch: rimuovere la chiave (o '0') + reload ⇒ il Cruscotto resta il v1
// vanilla (dashboard-module.js), identico a oggi. A flag spenta il bundle
// dash-v3 è INERTE (register.js non tocca il registry).
export function dashV3Enabled(win) {
  try {
    return win.localStorage.getItem('shell_dash_v3') === '1';
  } catch (e) {
    return false; // storage negato: default SPENTO — mai prendere il Cruscotto per sbaglio
  }
}

// F2.3b (secondo mattone): SOP v3 React — DEFAULT OFF nel bundle, stesso
// pattern del Cruscotto (dashV3Enabled). Si accende per-browser SOLO in collaudo
//   localStorage.shell_sop_v3 = '1'   (+ reload)
// e diventerà default ON con un deploy dedicato DOPO il collaudo utente.
// Kill-switch: rimuovere la chiave (o '0') + reload ⇒ SOP resta il v1 vanilla
// (sop-module.js), identico a oggi. A flag spenta il bundle sop-v3 (LAZY nel
// gruppo 'sop': zero costo al boot) è INERTE (register.js non tocca il registry).
export function sopV3Enabled(win) {
  try {
    return win.localStorage.getItem('shell_sop_v3') === '1';
  } catch (e) {
    return false; // storage negato: default SPENTO — mai prendere SOP per sbaglio
  }
}

// F2.3c (terzo mattone): PRIMA VISTA DEL MONOLITE in React — lista "Fornitori" —
// DEFAULT OFF nel bundle, stesso pattern dash/sop. Si accende per-browser SOLO
// in collaudo con
//   localStorage.shell_proc_v3_suppliers = '1'   (+ reload)
// e diventerà default ON con un deploy dedicato DOPO il collaudo utente.
// Kill-switch: rimuovere la chiave (o '0') + reload ⇒ la lista Fornitori resta
// il v1 del monolite (renderSuppliers di proc-v0.js), identico a oggi. A flag
// spenta il bundle proc-v3 (EAGER: il modulo proc è eager) è INERTE
// (install.js non installa il wrap di window.renderSuppliers).
export function procV3SuppliersEnabled(win) {
  try {
    return win.localStorage.getItem('shell_proc_v3_suppliers') === '1';
  } catch (e) {
    return false; // storage negato: default SPENTO — mai prendere la vista per sbaglio
  }
}

// F2.3d (quarto mattone, vista 2/3 del monolite): lista "Prodotti" in React —
// DEFAULT OFF nel bundle, stesso pattern di procV3SuppliersEnabled. Si accende
// per-browser SOLO in collaudo con
//   localStorage.shell_proc_v3_products = '1'   (+ reload)
// e diventerà default ON con un deploy dedicato DOPO il collaudo utente.
// Kill-switch: rimuovere la chiave (o '0') + reload ⇒ la lista Prodotti resta
// il v1 del monolite (renderProducts di proc-v0.js), identico a oggi. A flag
// spenta il wrap di window.renderProducts non viene MAI installato (install.js).
export function procV3ProductsEnabled(win) {
  try {
    return win.localStorage.getItem('shell_proc_v3_products') === '1';
  } catch (e) {
    return false; // storage negato: default SPENTO — mai prendere la vista per sbaglio
  }
}

// F2.3d (vista 3/3): lista "Campagne outreach" in React — DEFAULT OFF nel
// bundle, stesso pattern. Si accende per-browser SOLO in collaudo con
//   localStorage.shell_proc_v3_campaigns = '1'   (+ reload)
// Kill-switch: rimuovere la chiave (o '0') + reload ⇒ la lista Campagne resta
// il v1 del monolite (renderCampaigns di proc-v0.js), identico a oggi. A flag
// spenta il wrap di window.renderCampaigns non viene MAI installato (install.js).
export function procV3CampaignsEnabled(win) {
  try {
    return win.localStorage.getItem('shell_proc_v3_campaigns') === '1';
  } catch (e) {
    return false; // storage negato: default SPENTO — mai prendere la vista per sbaglio
  }
}

// F2.3e (vista 4/N del monolite): lista "Conversazioni" in React — DEFAULT OFF
// nel bundle, stesso pattern. Si accende per-browser SOLO in collaudo con
//   localStorage.shell_proc_v3_conversations = '1'   (+ reload)
// Kill-switch: rimuovere la chiave (o '0') + reload ⇒ la lista Conversazioni
// resta il v1 del monolite (renderConversations di proc-v0.js), identico a oggi.
// A flag spenta il wrap di window.renderConversations non viene MAI installato.
// NB: badge nav (.conv-counter) e poller globale startConversationsPoll restano
// SEMPRE del v1 (vivono fuori dalla vista): la flag non li tocca.
export function procV3ConversationsEnabled(win) {
  try {
    return win.localStorage.getItem('shell_proc_v3_conversations') === '1';
  } catch (e) {
    return false; // storage negato: default SPENTO — mai prendere la vista per sbaglio
  }
}

// F2.3e (vista 5/N): lista "Ordini" in React — DEFAULT OFF nel bundle, stesso
// pattern. Si accende per-browser SOLO in collaudo con
//   localStorage.shell_proc_v3_orders = '1'   (+ reload)
// Kill-switch: rimuovere la chiave (o '0') + reload ⇒ la lista Ordini resta
// il v1 del monolite (renderOrders di proc-v0.js), identico a oggi. A flag
// spenta il wrap di window.renderOrders non viene MAI installato (install.js).
export function procV3OrdersEnabled(win) {
  try {
    return win.localStorage.getItem('shell_proc_v3_orders') === '1';
  } catch (e) {
    return false; // storage negato: default SPENTO — mai prendere la vista per sbaglio
  }
}

// F2.3f (vista 6/N): lista "Tag" in React — DEFAULT OFF nel bundle, stesso
// pattern. Si accende per-browser SOLO in collaudo con
//   localStorage.shell_proc_v3_tags = '1'   (+ reload)
// Kill-switch: rimuovere la chiave (o '0') + reload ⇒ la lista Tag resta
// il v1 del monolite (renderTags di proc-v0.js), identico a oggi. A flag
// spenta il wrap di window.renderTags non viene MAI installato (install.js).
export function procV3TagsEnabled(win) {
  try {
    return win.localStorage.getItem('shell_proc_v3_tags') === '1';
  } catch (e) {
    return false; // storage negato: default SPENTO — mai prendere la vista per sbaglio
  }
}

// F2.3f (vista 7/N): "Magazzino" in React — DEFAULT OFF nel bundle, stesso
// pattern. Si accende per-browser SOLO in collaudo con
//   localStorage.shell_proc_v3_warehouse = '1'   (+ reload)
// Kill-switch: rimuovere la chiave (o '0') + reload ⇒ il Magazzino resta
// il v1 del monolite (renderWarehouse di proc-v0.js), identico a oggi. A flag
// spenta il wrap di window.renderWarehouse non viene MAI installato.
// NB: il tab attivo vive in window._whTab (globale del monolite, CONDIVISO
// v1↔v3: cambiando flag si resta sullo stesso tab) e il tab "DDT & Partite"
// DELEGA il mount al modulo v1 window.WarehouseDDT (warehouse-ddt.js), con lo
// stesso fallback del v1 se il modulo non è (ancora) caricato.
export function procV3WarehouseEnabled(win) {
  try {
    return win.localStorage.getItem('shell_proc_v3_warehouse') === '1';
  } catch (e) {
    return false; // storage negato: default SPENTO — mai prendere la vista per sbaglio
  }
}

// F2.3g (vista 8/N): "Monitoraggio" in React — DEFAULT OFF nel bundle, stesso
// pattern. Si accende per-browser SOLO in collaudo con
//   localStorage.shell_proc_v3_monitoring = '1'   (+ reload)
// Kill-switch: rimuovere la chiave (o '0') + reload ⇒ il Monitoraggio resta
// il v1 del monolite (renderMonitoring di proc-v0.js), identico a oggi. A flag
// spenta il wrap di window.renderMonitoring non viene MAI installato.
// NB: i modali "Esegui ora" (_confirmRunSchedule) e "Cronologia"
// (_showScheduleHistory) restano SEMPRE del v1 (deleghe): la flag non li tocca.
export function procV3MonitoringEnabled(win) {
  try {
    return win.localStorage.getItem('shell_proc_v3_monitoring') === '1';
  } catch (e) {
    return false; // storage negato: default SPENTO — mai prendere la vista per sbaglio
  }
}

// F2.3g (vista 9/N): "Templates" (Libreria modelli) in React — DEFAULT OFF nel
// bundle, stesso pattern. Si accende per-browser SOLO in collaudo con
//   localStorage.shell_proc_v3_templates = '1'   (+ reload)
// Kill-switch: rimuovere la chiave (o '0') + reload ⇒ la Libreria modelli
// resta il v1 del monolite (renderTemplates di proc-v0.js), identico a oggi.
// A flag spenta il wrap di window.renderTemplates non viene MAI installato.
// NB: il modale del template (openTemplateModal) resta SEMPRE del v1 (delega).
export function procV3TemplatesEnabled(win) {
  try {
    return win.localStorage.getItem('shell_proc_v3_templates') === '1';
  } catch (e) {
    return false; // storage negato: default SPENTO — mai prendere la vista per sbaglio
  }
}

// F2.3h (vista 10/N): "Categorie" (albero tassonomia) in React — DEFAULT OFF
// nel bundle, stesso pattern. Si accende per-browser SOLO in collaudo con
//   localStorage.shell_proc_v3_categories = '1'   (+ reload)
// Kill-switch: rimuovere la chiave (o '0') + reload ⇒ le Categorie restano
// il v1 del monolite (renderCategories di proc-v0.js), identico a oggi. A
// flag spenta il wrap di window.renderCategories non viene MAI installato.
// NB: i modali delegati (prodotto/fornitore/preventivo/AI) restano SEMPRE
// del v1; il drag&drop resta SOLO nel v1 (confine dichiarato f23h — in v3 lo
// spostamento passa da Taglia/Incolla del menu contestuale, stessa primitiva
// confirmWrite.moveCategory).
export function procV3CategoriesEnabled(win) {
  try {
    return win.localStorage.getItem('shell_proc_v3_categories') === '1';
  } catch (e) {
    return false; // storage negato: default SPENTO — mai prendere la vista per sbaglio
  }
}

// E1 EMAIL-v3 (ondata 24, prima ondata del cantiere — spike f23h): modulo
// Posta v3 React, FLAG UNICA per l'intero modulo (strategia PER-MODULO della
// spike §2.2, pattern sop-v3) — DEFAULT ON nel bundle (deploy "accensione" E4,
// collaudo utente APPROVATO 2026-07-21: HTML/rich-text, lettura WhatsApp, taglio
// storico + toggle, composer completo con tabelle/font — tutto verificato).
// Kill-switch per-browser: impostare
//   localStorage.shell_email_v3 = '0'   (+ reload)
// ⇒ Posta torna il v1 vanilla (email-module.js), identico a prima.
// A flag in kill-switch il bundle email-v3 (LAZY
// nel gruppo 'email': zero costo al boot) è INERTE (install non tocca il
// registry). In E1 il v3 copre la LISTA (inbox/follow-up/dipartimenti);
// conversazione (E2) e pannelli di gestione (E3) sono confini dichiarati.
export function emailV3Enabled(win) {
  try {
    // DEFAULT ON: qualunque valore diverso da '0' (chiave assente inclusa) ⇒ v3.
    return win.localStorage.getItem('shell_email_v3') !== '0';
  } catch (e) {
    return true; // storage negato: default ON (la Posta v3 è la vista predefinita)
  }
}

// A1 AMM-v3 (ondata 28, prima ondata del cantiere — spike o27): PRIMA VISTA
// di Amministrazione in React — il CRUSCOTTO scadenze (la vista che elenca le
// amm_scadenze; decisione vista+seam registrata in a1-01) — DEFAULT OFF nel
// bundle, FLAG PER-VISTA come proc-v3 (strategia PER-VISTA della spike §2.2:
// il seam esiste, wrap di AMM.renderPage). Si accende per-browser SOLO in
// collaudo con
//   localStorage.shell_amm_v3_cruscotto = '1'   (+ reload)
// e diventerà default ON con un deploy dedicato DOPO il collaudo utente.
// Kill-switch: rimuovere la chiave (o '0') + reload ⇒ il Cruscotto amm resta
// il v1 vanilla (renderCruscotto di admin-module.js), identico a oggi. A flag
// spenta il bundle amm-v3 (EAGER: admin-module è eager fino a R8) è INERTE
// (install.js non installa il wrap di AMM.renderPage).
export function ammV3CruscottoEnabled(win) {
  try {
    return win.localStorage.getItem('shell_amm_v3_cruscotto') === '1';
  } catch (e) {
    return false; // storage negato: default SPENTO — mai prendere la vista per sbaglio
  }
}

// A2 AMM-v3 (ondata 29, seconda ondata del cantiere): vista "Regole degli
// obblighi" (pagina 'scadenzario': il CATALOGO delle regole che generano le
// scadenze — spike o27 §1.2) in React — DEFAULT OFF nel bundle, FLAG
// PER-VISTA come il Cruscotto A1. Si accende per-browser SOLO in collaudo con
//   localStorage.shell_amm_v3_scadenzario = '1'   (+ reload)
// Kill-switch: rimuovere la chiave (o '0') + reload ⇒ la pagina resta il v1
// vanilla (renderScadenzario di admin-module.js), identico a oggi. A flag
// spenta la vista non entra MAI nel registry del wrap (install inerte).
export function ammV3ScadenzarioEnabled(win) {
  try {
    return win.localStorage.getItem('shell_amm_v3_scadenzario') === '1';
  } catch (e) {
    return false; // storage negato: default SPENTO — mai prendere la vista per sbaglio
  }
}

// A2 AMM-v3 (ondata 29): vista GENERICA "Anagrafiche" in React — UNA vista
// per le 8 pagine veicoli/polizze/documenti/dipendenti/atti/immobili/crediti/
// cantieri (il v1 le serve tutte con renderAnagrafica(el, key): il pilota
// DataTable indicato dalla spike o27 §2.3). FLAG UNICA per la vista generica
// (8 entry nel registry), DEFAULT OFF. Si accende per-browser SOLO in collaudo
//   localStorage.shell_amm_v3_anagrafiche = '1'   (+ reload)
// Kill-switch: rimuovere la chiave (o '0') + reload ⇒ le 8 pagine restano il
// v1 vanilla, identiche a oggi. A flag spenta nessuna entry entra nel registry.
export function ammV3AnagraficheEnabled(win) {
  try {
    return win.localStorage.getItem('shell_amm_v3_anagrafiche') === '1';
  } catch (e) {
    return false; // storage negato: default SPENTO — mai prendere le viste per sbaglio
  }
}

// A3 AMM-v3 (ondata 30, terza ondata del cantiere): vista "Calendario
// scadenze" (pagina 'calendario': griglia mensile delle amm_scadenze) in
// React sul componente condiviso MonthGrid — DEFAULT OFF nel bundle, FLAG
// PER-VISTA come A1/A2. Si accende per-browser SOLO in collaudo con
//   localStorage.shell_amm_v3_calendario = '1'   (+ reload)
// Kill-switch: rimuovere la chiave (o '0') + reload ⇒ la pagina resta il v1
// vanilla (renderCalendario di admin-module.js), identico a oggi. A flag
// spenta la vista non entra MAI nel registry del wrap (install inerte).
export function ammV3CalendarioEnabled(win) {
  try {
    return win.localStorage.getItem('shell_amm_v3_calendario') === '1';
  } catch (e) {
    return false; // storage negato: default SPENTO — mai prendere la vista per sbaglio
  }
}

// A3 AMM-v3 (ondata 30): vista "Riepilogo annuale" (pagina 'riepilogo':
// carico fiscale dell'anno, KPI + per gruppo + distribuzione mensile, con
// STAMPA A5-039 e export ZIP) in React — DEFAULT OFF, FLAG PER-VISTA.
//   localStorage.shell_amm_v3_riepilogo = '1'   (+ reload)
// Kill-switch: rimuovere la chiave (o '0') + reload ⇒ v1 vanilla
// (renderRiepilogo), identico a oggi.
export function ammV3RiepilogoEnabled(win) {
  try {
    return win.localStorage.getItem('shell_amm_v3_riepilogo') === '1';
  } catch (e) {
    return false; // storage negato: default SPENTO — mai prendere la vista per sbaglio
  }
}

// A3 AMM-v3 (ondata 30): vista "Resoconto d'insieme" (pagina 'resoconto':
// matrice tipologia×mese con semantica null-vs-0 A3-080/A5-054, confronto
// anno-1, drill-down) in React — DEFAULT OFF, FLAG PER-VISTA.
//   localStorage.shell_amm_v3_resoconto = '1'   (+ reload)
// Kill-switch: rimuovere la chiave (o '0') + reload ⇒ v1 vanilla
// (renderResoconto), identico a oggi.
export function ammV3ResocontoEnabled(win) {
  try {
    return win.localStorage.getItem('shell_amm_v3_resoconto') === '1';
  } catch (e) {
    return false; // storage negato: default SPENTO — mai prendere la vista per sbaglio
  }
}

// A4 AMM-v3 (ondata 31, QUARTA ondata del cantiere): vista "Costo personale"
// (pagina 'personale': matrice dipendente×mese dai cedolini + quadratura
// cedolini↔F24, spike o27 §1.2) in React — DEFAULT OFF nel bundle, FLAG
// PER-VISTA come A1/A2/A3. Si accende per-browser SOLO in collaudo con
//   localStorage.shell_amm_v3_personale = '1'   (+ reload)
// Kill-switch: rimuovere la chiave (o '0') + reload ⇒ la pagina resta il v1
// vanilla (renderPersonale di admin-module.js), identico a oggi. A flag spenta
// la vista non entra MAI nel registry del wrap (install inerte).
export function ammV3PersonaleEnabled(win) {
  try {
    return win.localStorage.getItem('shell_amm_v3_personale') === '1';
  } catch (e) {
    return false; // storage negato: default SPENTO — mai prendere la vista per sbaglio
  }
}

// A4 AMM-v3 (ondata 31): vista "Voci & trasferte" (pagina 'voci': aggregato
// categoria×dipendente×mese sulle voci del cedolino, spike o27 §1.2) in React —
// DEFAULT OFF nel bundle, FLAG PER-VISTA.
//   localStorage.shell_amm_v3_voci = '1'   (+ reload)
// Kill-switch: rimuovere la chiave (o '0') + reload ⇒ v1 vanilla (renderVoci),
// identico a oggi.
export function ammV3VociEnabled(win) {
  try {
    return win.localStorage.getItem('shell_amm_v3_voci') === '1';
  } catch (e) {
    return false; // storage negato: default SPENTO — mai prendere la vista per sbaglio
  }
}

// A4 AMM-v3 (ondata 31): vista "Bilanci e archivio" (pagina 'esercizi': slot
// documenti d'esercizio per anno — bilanci, dichiarazioni, verbali, spike o27
// §1.2/§2.3 CardGrid) in React — DEFAULT OFF nel bundle, FLAG PER-VISTA.
//   localStorage.shell_amm_v3_esercizi = '1'   (+ reload)
// Kill-switch: rimuovere la chiave (o '0') + reload ⇒ v1 vanilla
// (renderEsercizi), identico a oggi.
export function ammV3EserciziEnabled(win) {
  try {
    return win.localStorage.getItem('shell_amm_v3_esercizi') === '1';
  } catch (e) {
    return false; // storage negato: default SPENTO — mai prendere la vista per sbaglio
  }
}

// A5 AMM-v3 (ondata 32, QUINTA ondata del cantiere): vista "Imposte dell'anno"
// (pagina 'tributi': piano imposte ad ALBERO categoria→tributo→voce→occorrenze
// — spike o27 §1.2/§2.3, pilota TreeView) in React — DEFAULT OFF nel bundle,
// FLAG PER-VISTA come A1..A4. Si accende per-browser SOLO in collaudo con
//   localStorage.shell_amm_v3_tributi = '1'   (+ reload)
// Kill-switch: rimuovere la chiave (o '0') + reload ⇒ v1 vanilla (renderTributi
// di admin-module.js), identico a oggi. A flag spenta la vista non entra MAI
// nel registry del wrap (install inerte).
export function ammV3TributiEnabled(win) {
  try {
    return win.localStorage.getItem('shell_amm_v3_tributi') === '1';
  } catch (e) {
    return false; // storage negato: default SPENTO — mai prendere la vista per sbaglio
  }
}

// A5 AMM-v3 (ondata 32): vista "Piani di rientro" (pagina 'rateizzazioni':
// lista dei piani di rateazione con KPI, editor e dettaglio-rate DELEGATI al
// v1 — spike o27 §1.2) in React — DEFAULT OFF nel bundle, FLAG PER-VISTA.
//   localStorage.shell_amm_v3_rateizzazioni = '1'   (+ reload)
// Kill-switch: rimuovere la chiave (o '0') + reload ⇒ v1 vanilla
// (renderRateizzazioni), identico a oggi.
export function ammV3RateizzazioniEnabled(win) {
  try {
    return win.localStorage.getItem('shell_amm_v3_rateizzazioni') === '1';
  } catch (e) {
    return false; // storage negato: default SPENTO — mai prendere la vista per sbaglio
  }
}

// A5 AMM-v3 (ondata 32): vista interna "Costi per cantiere" (pagina
// 'cantieri-costi': aggregato read-only trasferte/veicoli/polizze/crediti per
// cantiere, raggiunta dalla pagina Cantieri — spike o27 §1.2) in React —
// DEFAULT OFF nel bundle, FLAG PER-VISTA.
//   localStorage.shell_amm_v3_cantieri_costi = '1'   (+ reload)
// Kill-switch: rimuovere la chiave (o '0') + reload ⇒ v1 vanilla
// (renderCantieriCosti), identico a oggi.
export function ammV3CantieriCostiEnabled(win) {
  try {
    return win.localStorage.getItem('shell_amm_v3_cantieri_costi') === '1';
  } catch (e) {
    return false; // storage negato: default SPENTO — mai prendere la vista per sbaglio
  }
}

// A6 AMM-v3 (ondata 33, SESTA ondata del cantiere): vista "Profilo azienda"
// (pagina 'profilo', l'HUB — scheda azienda + 8 flag fiscali + anteprima/salva
// + sotto-sezioni Tipologie/Parametri/Proroghe NATIVE e pannelli Promemoria/
// Registro/Spazio/Cestino DELEGATI al v1 — spike o27 §1.2) in React — DEFAULT
// OFF nel bundle, FLAG UNICA per l'intero hub (il seam è renderPage→renderProfilo,
// una sola vista: nessun dispatch per-sotto-sezione). Si accende per-browser SOLO
// in collaudo con
//   localStorage.shell_amm_v3_profilo = '1'   (+ reload)
// Kill-switch: rimuovere la chiave (o '0') + reload ⇒ v1 vanilla (renderProfilo
// di admin-module.js), identico a oggi. A flag spenta la vista non entra MAI nel
// registry del wrap (install inerte).
export function ammV3ProfiloEnabled(win) {
  try {
    return win.localStorage.getItem('shell_amm_v3_profilo') === '1';
  } catch (e) {
    return false; // storage negato: default SPENTO — mai prendere la vista per sbaglio
  }
}

// A7 AMM-v3 (ondata 34, SETTIMA e ULTIMA ondata del cantiere): vista "Pagamenti
// F24" (pagina 'f24' — la LISTA dei modelli F24/versamenti; il WIZARD AI di
// import quietanze resta DELEGATO al v1, confine dichiarato come le rate in A5 —
// spike o27 §1.2) in React — DEFAULT OFF nel bundle, FLAG PER-VISTA come A1..A6.
// Si accende per-browser SOLO in collaudo con
//   localStorage.shell_amm_v3_f24 = '1'   (+ reload)
// Kill-switch: rimuovere la chiave (o '0') + reload ⇒ v1 vanilla (renderF24 di
// admin-module.js), identico a oggi. A flag spenta la vista non entra MAI nel
// registry del wrap (install inerte). Chiude la migrazione React di AMM (21/21).
export function ammV3F24Enabled(win) {
  try {
    return win.localStorage.getItem('shell_amm_v3_f24') === '1';
  } catch (e) {
    return false; // storage negato: default SPENTO — mai prendere la vista per sbaglio
  }
}

// R7: kill-switch PER-BROWSER del lazy-load (design §11 R7 — il rollback
// PRINCIPALE resta manifest-only: togliere `lazy` dal loading-order + rebuild).
// localStorage.shell_lazy='0' (+ reload) ⇒ la shell fa preloadAll() al boot:
// tutti i gruppi lazy si caricano SUBITO — resa "quasi eager" senza redeploy,
// per l'utente a cui il caricamento on-demand desse problemi.
export function lazyModulesEnabled(win) {
  try {
    return win.localStorage.getItem('shell_lazy') !== '0';
  } catch (e) {
    return true;
  }
}
